document.addEventListener('alpine:init', function () {
    Alpine.data('homeFeaturedCollection', function () {
        var glide;
        return {
            activeSlide: 0,
            init: function () {
                this.initialiseCarousel();
            },
            initialiseCarousel: function () {
                var _this = this;
                glide = new window.Glide(this.$refs.carousel, {
                    type: 'carousel',
                    gap: 30,
                    // peek: { before: 0, after: 100 },
                }).mount();
                glide.on(['move.after', 'run'], function () {
                    _this.activeSlide = glide.index;
                    // Set slides that are not active to be 'inert'.
                    var slides = Array.from(_this.$refs.carousel.querySelectorAll('.glide__slide'));
                    slides.forEach(function (slide) {
                        var isActive = slide.classList.contains('glide__slide--active');
                        if (isActive) {
                            slide.removeAttribute('inert');
                        }
                        else {
                            slide.setAttribute('inert', '');
                        }
                    });
                });
            },
        };
    });
});
